import { render, staticRenderFns } from "./MedicineInputGroup.vue?vue&type=template&id=dcb4f3b0&scoped=true&"
import script from "./MedicineInputGroup.vue?vue&type=script&lang=ts&"
export * from "./MedicineInputGroup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcb4f3b0",
  null
  
)

export default component.exports